export function items(state, data) {
  state.items = data
}
export function pagination(state, data) {
  state.pagination = data
}

export function item(state, data) {
  state.item = data
}

export function companies(state, data) {
  state.companies = data
}

export function statistics(state, data) {
  state.statistics = data
}

export function projectsItems(state, data) {
  state.projectsItems = data
}

export function platforms(state, data) {
  state.platforms = data
}
